import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 5px;
  padding-top: 5px;
`

export const StatusContainer = styled.div`
  border: 1px solid #f8f8f8;
  padding: 5px;
`

interface StatusContentProps {
  withBorderTop?: boolean;
  withBorderBottom?: boolean;
  contentColor?: string;
}

export const StatusContent = styled.div<StatusContentProps>`
  display: flex;
  justify-content: space-between;
  border-top: ${props => props.withBorderTop ? '1px solid #f8f8f8' : 'none' };
  border-bottom: ${props => props.withBorderBottom ? '1px solid #f8f8f8' : 'none' };
  font-size: 0.9em;
  color: ${props => props.contentColor || 'inherit'}
`;

export const TableDocument = styled.table`
  width: 100%;
  background-color: #f8f8f8;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
`;

interface TableHeaderTitleProps {
  width?: string;
}

export const TableHeaderTitle = styled.th<TableHeaderTitleProps>`
  padding-bottom: 0px;
  font-weight: bold;
  color: #999;
  font-size: 0.8em;
  padding: 5px 5px 0px 5px;
  width: ${props => props.width || 'auto'};
  min-width: ${props => props.width || 'auto'};
  max-width: ${props => props.width || 'auto'};
`;

export const TableData = styled.th`
  font-size: 0.9em;
  padding: 5px;
  font-weight: normal;
`;

export const TrackingCodeChangeButton = styled.button`
  margin-left: 10px;
  border: none;
  border-radius: 5px;
  padding: 0px;
`;